module.exports = __webpack_public_path__ + "static/media/asurion-hero-tablet.124aed24.jpg";


//////////////////
// WEBPACK FOOTER
// ./packages/smart-home-support/assets/resources/SHS-ASURION/asurion-hero-tablet.jpg
// module id = 1385
// module chunks = 0